import { useContext } from 'react';
import { DateSelectionContext } from '../../context/DateSelectionContext';

const useDate = () => useContext(DateSelectionContext);

export default useDate;
